export default __webpack_public_path__ + "static/media/loading.749129e5.svg";